import React from 'react';
import { withRouter } from 'react-router-dom';
import Button from './Button';
import Icon from '../../refresh/atoms/Icon';

class BackButton extends React.Component {
  render() {
    const style = Object.freeze({
      fontSize: '2rem',
      fontWeight: 'bold'
    });
    const luxeStyle = Object.freeze({
      fontSize: '2.4rem',
      fontWeight: 'bold'
    });
    const fleekStyle = Object.freeze({
      fontSize: '2rem',
      fontWeight: 'bold',
      color : '#FFF'
    });

    const {
      history,
      className = '',
      iconClassName = 'ic-back',
      luxe = false,
      isFleek = false,
      isLimitedScrollLandingPage = false
   , ariaLabel="Back" } = this.props;

    return (
      <Button
        className={`rilrtl-button--back ${className}`}
        onClick={() => {
          if (!isLimitedScrollLandingPage) {
            history.goBack();
          }

          if (this.props.onClick) {
            this.props.onClick();
          }
        }}
        ariaLabel={ariaLabel}
      >
        <Icon ariaHidden={true} icon="icon-Back" styles={luxe ? luxeStyle : isFleek ? fleekStyle : style} />
      </Button>
    );
  }
}

export default withRouter(BackButton);
